import {Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ModalController, Platform} from '@ionic/angular';
import {ScreenOrientation} from '@ionic-native/screen-orientation/ngx';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-hd',
    templateUrl: './hd.component.html',
    styleUrls: ['./hd.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class HdComponent implements OnInit, OnDestroy {
    @ViewChild('hdTXCB', {static: false}) elHdTXCB: ElementRef;
    subscriptionScreenOri: Subscription;
    isLandscape = false;

    constructor(
        private modalCtr: ModalController,
        private screenOrientation: ScreenOrientation,
        public platform: Platform
    ) {
        platform.ready().then((readySource) => {
            this.detectScreenOrient();
        });
        this.subscriptionScreenOri = screenOrientation.onChange().subscribe(
            () => {
                this.detectScreenOrient();
            }
        );
    }

    detectScreenOrient() {
        setTimeout(() => {
            const pH = this.platform.height();
            const pW = this.platform.width();
            let hGame = 0;
            if (pW > pH) {
                this.isLandscape = true;
                hGame = 305;
            } else if (pW < pH) {
                this.isLandscape = false;
                hGame = 400;
            }

            if (pH < hGame) {
                this.elHdTXCB.nativeElement.style.transform = `scale(${(pH / hGame)})`;
            } else {
                this.elHdTXCB.nativeElement.style.transform = `scale(1)`;
            }
        }, 100);
    }

    ngOnInit() {}

    ngOnDestroy(): void {
        this.subscriptionScreenOri.unsubscribe();
    }

    async closeModal() {
        await this.modalCtr.dismiss();
    }
}
